module.exports = __webpack_public_path__ + "img/Performing-Art-Deck--26774-005.a4624836.jpg";